import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

import { MyExamScoreFragment } from '../../GraphQL/query/fragments/ExamFragment';

import ExamScore from '../../Components/ExamScore';

const myExamScoreQuery = gql`
  query myExamScore {
    myProfile {
      id
      myScores {
        ...MyExamScoreFragment
      }
    }
  }
  ${MyExamScoreFragment}
`;

const MyScore = graphql(myExamScoreQuery, {
  name: 'myScoreData',
  props: ({ myScoreData }) => {
    return {
      myScoreLoading: myScoreData.networkStatus < 7,
      myScoreError: myScoreData.error,
      myScores: myScoreData.myProfile ? myScoreData.myProfile.myScores : [],
    };
  },
  skip: ({ enableScoreCalc }) => !enableScoreCalc,
});

export default compose(MyScore)(ExamScore);
